module.exports = __webpack_public_path__ + "static/media/ucd-logo.4debde87.png";